import React from 'react'
import { IconProps } from '../types'

export default function MenuIcon({
    className = 'h-4 w-4',
    fill = 'currentColor',
    ...props
}: IconProps) {
    return (
        <svg
            width="15"
            height="9"
            viewBox="0 0 15 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M1.27778 8.99999C1.05741 8.99999 0.872817 8.92799 0.724003 8.78399C0.575188 8.63999 0.500521 8.46199 0.500003 8.24999C0.499484 8.03799 0.574151 7.85999 0.724003 7.71599C0.873854 7.57199 1.05845 7.49999 1.27778 7.49999H13.7222C13.9426 7.49999 14.1274 7.57199 14.2768 7.71599C14.4261 7.85999 14.5005 8.03799 14.5 8.24999C14.4995 8.46199 14.4248 8.64024 14.276 8.78474C14.1272 8.92924 13.9426 9.00099 13.7222 8.99999H1.27778ZM1.27778 5.24999C1.05741 5.24999 0.872817 5.17799 0.724003 5.03399C0.575188 4.88999 0.500521 4.71199 0.500003 4.49999C0.499484 4.288 0.574151 4.11 0.724003 3.966C0.873854 3.822 1.05845 3.75 1.27778 3.75H13.7222C13.9426 3.75 14.1274 3.822 14.2768 3.966C14.4261 4.11 14.5005 4.288 14.5 4.49999C14.4995 4.71199 14.4248 4.89024 14.276 5.03474C14.1272 5.17924 13.9426 5.25099 13.7222 5.24999H1.27778ZM1.27778 1.5C1.05741 1.5 0.872817 1.428 0.724003 1.284C0.575188 1.14 0.500521 0.961999 0.500003 0.749999C0.499484 0.537999 0.574151 0.36 0.724003 0.216C0.873854 0.072 1.05845 0 1.27778 0H13.7222C13.9426 0 14.1274 0.072 14.2768 0.216C14.4261 0.36 14.5005 0.537999 14.5 0.749999C14.4995 0.961999 14.4248 1.14025 14.276 1.28475C14.1272 1.42925 13.9426 1.501 13.7222 1.5H1.27778Z"
                fill={fill}
            />
        </svg>
    )
}
